<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-text-field
          v-model="search"
          :label="$t('common.search')"
          class="mx-2"
        />
        <div class="overline primary--text pr-1 text-left">
          {{ $t("formula.toolbarTitle") }}
        </div>
        <v-data-table
          :headers="headers"
          :items="formulas"
          :items-per-page="15"
          class="elevation-1"
          :search="search"
        >
          <template v-slot:item.active="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  :color="item.active ? 'success' : 'error'"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ item.active ? "mdi-check" : "mdi-window-close" }}
                </v-icon>
              </template>
              <span>{{
                item.active ? $t("common.active") : $t("common.notActive")
              }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.awaitAllInput="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  {{ item.awaitAllInput ? "mdi-clock-in" : "mdi-share-all" }}
                </v-icon>
              </template>
              <span>{{
                item.awaitAllInput
                  ? $t("formula.tooltips.awaiting")
                  : $t("formula.tooltips.notAwaiting")
              }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.executedAt="{ item }">
            {{ humanDate(item.executedAt) }}
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon
              v-if="permitted('Formula.Update')"
              @click="editFormula(item)"
              class="mr-2"
              color="primary"
            >
              mdi-pencil
            </v-icon>

            <v-icon
              v-if="permitted('Formula.Delete')"
              dark
              color="error"
              @click="openConfirm(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>

      <delete-dialog
        :dialog="confirmDelete"
        v-on:confirm-delete="removeFormula"
        v-on:cancel-dialog="confirmDelete = false"
      />
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
import DeleteDialog from "@/components/common/DeleteDialog";

export default {
  name: "FormulaList",

  data() {
    return {
      confirmDelete: false,
      currentId: null,
      search: "",

      headers: [
        { text: this.$t("formula.fields.active"), value: "active" },
        { text: this.$t("formula.fields.name"), value: "name" },
        {
          text: this.$t("formula.fields.awaitAllInput"),
          value: "awaitAllInput",
        },
        {
          text: this.$t("formula.fields.output"),
          value: "output",
        },
        { text: this.$t("formula.fields.executedAt"), value: "executedAt" },
        { text: "", value: "action", sortable: false },
      ],
    };
  },

  computed: {
    ...mapState("formulas", ["formulas"]),
  },

  methods: {
    ...mapActions("formulas", ["getFormulas", "deleteFormula"]),

    editFormula(item) {
      this.$router.push(`/formula/${item.formulaId}`);
    },

    async removeFormula() {
      if (this.currentId == null || this.currentId == undefined) {
        this.error(this.$t("formula.errors.noId"));
        return;
      }

      if (!(await this.deleteFormula(this.currentId)))
        this.error(this.$t("formula.errors.delete"));
      this.confirmDelete = false;
      await this.getFormulas();
    },

    openConfirm(formula) {
      this.currentId = formula.formulaId;
      this.confirmDelete = true;
    },
  },

  async created() {
    await this.getFormulas();
  },

  components: {
    DeleteDialog,
  },
};
</script>
